// extracted by mini-css-extract-plugin
export default {"info":"BKNTG","color":"uDWCw","inner":"oysfM","text":"zD7Rz","value":"Cu8QG"};